import { useTranslation } from "react-i18next"
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card"
import { GymBrandingForm } from "@/components/profile/gym-branding-form"

export default function GymSettingsPage() {
  const { t } = useTranslation()

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">{t("gymSettings.title", "Gym Settings")}</h1>

      <Card>
        <CardHeader>
          <CardTitle>{t("gymSettings.branding", "Branding")}</CardTitle>
          <CardDescription>
            {t(
              "gymSettings.brandingDescription",
              "Manage your gym's branding — logo, name and primary color shown across the app and login page."
            )}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <GymBrandingForm />
        </CardContent>
      </Card>
    </div>
  )
}
